export default {
  getMemberList: (state: any) => state.teamMemberList,
};
